var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Tabs/Button.ios.js";var React=require("react");
var ReactNative=require("react-native");var
TouchableOpacity=ReactNative.TouchableOpacity,View=ReactNative.View;

var Button=function Button(props){
return(
React.createElement(TouchableOpacity,_extends({activeOpacity:0.6},props,{__source:{fileName:_jsxFileName,lineNumber:7}}),
props.children));


};

module.exports=Button;
//# sourceMappingURL=Button.ios.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/basic/Tabs/Button.ios.js
// module id = 221
// module chunks = 0